export type ParsePageFieldToDateOptions = {
  /** PrimeVue time-only picker (HH:mm) — keep clock time on today's date */
  timeOnly?: boolean
}

function unwrapFieldScalar(field: unknown): unknown {
  if (field == null) return field
  if (field instanceof Date) return field
  if (typeof field !== 'object' || Array.isArray(field)) return field

  const obj = field as Record<string, unknown>
  if ('value' in obj) {
    const inner = obj.value
    if (inner != null && typeof inner === 'object' && !Array.isArray(inner) && 'value' in inner) {
      return (inner as { value?: unknown }).value
    }
    return inner
  }
  return field
}

function parseDateScalar(raw: unknown): Date | null {
  if (raw == null || raw === '') return null
  if (raw instanceof Date) {
    return Number.isNaN(raw.getTime()) ? null : raw
  }

  if (typeof raw === 'number' && Number.isFinite(raw)) {
    const dt = new Date(raw)
    return Number.isNaN(dt.getTime()) ? null : dt
  }

  const str = String(raw).trim()
  if (!str) return null

  const dm = /^(\d{2})\.(\d{2})\.(\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/.exec(str)
  if (dm) {
    const d = Number.parseInt(dm[1], 10)
    const mo = Number.parseInt(dm[2], 10) - 1
    const y = Number.parseInt(dm[3], 10)
    const h = dm[4] != null ? Number.parseInt(dm[4], 10) : 0
    const mi = dm[5] != null ? Number.parseInt(dm[5], 10) : 0
    const s = dm[6] != null ? Number.parseInt(dm[6], 10) : 0
    const dt = new Date(y, mo, d, h, mi, s)
    return Number.isNaN(dt.getTime()) ? null : dt
  }

  const tm = /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/.exec(str)
  if (tm) {
    const now = new Date()
    const h = Number.parseInt(tm[1], 10)
    const mi = Number.parseInt(tm[2], 10)
    const s = tm[3] != null ? Number.parseInt(tm[3], 10) : 0
    const dt = new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, mi, s)
    return Number.isNaN(dt.getTime()) ? null : dt
  }

  const iso = new Date(str)
  if (!Number.isNaN(iso.getTime())) return iso

  return null
}

/**
 * Нормализует значение поля страницы (UniData Date / GMT string / epoch) в Date для MDatePicker.
 */
export function parsePageFieldToDate(
  field: unknown,
  options?: ParsePageFieldToDateOptions,
): Date | null {
  const scalar = unwrapFieldScalar(field)
  const parsed = parseDateScalar(scalar)
  if (!parsed) return null

  if (options?.timeOnly) {
    const now = new Date()
    return new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      parsed.getHours(),
      parsed.getMinutes(),
      parsed.getSeconds(),
      parsed.getMilliseconds(),
    )
  }

  return parsed
}
